import { useState } from "react";
import { Container, Button, Row, Col, Form, Spinner } from "react-bootstrap";

import "./index.scss";
import { useBetween } from "use-between";
import useShopify from "../../../useShopify";
import { useParams } from "react-router-dom";

const Review = ({ prev, next, form }) => {
  const { company, campaign: campaignName } = useParams();
  const { campaign, product, createOrder, note, image } =
    useBetween(useShopify);

  const isEncore = campaign.companyId === "65cd150fdc2cf13513530120";
  const isLiveNation = campaign.companyId === "65d52364dc2cf135135301fd";

  const [pending, setPending] = useState(false);

  const handleSubmit = () => {
    // e.preventDefault();
    setPending(true);

    const formData = new FormData();
    formData.append("campaignId", campaign._id);
    formData.append("firstName", form.firstName);
    formData.append("lastName", form.lastName);
    formData.append("companyName", form.companyName);
    formData.append("originalCompany", company);
    formData.append("streetAddress", form.streetAddress);
    formData.append("suite", form.suite);
    formData.append("city", form.city);
    formData.append("state", form.state);
    formData.append("postalCode", form.postalCode);
    formData.append("country", form.country);
    formData.append("phoneNumber", form.phoneNumber);
    formData.append("email", form.email);
    formData.append("size", form.size);
    formData.append("boxName", product.handle);
    formData.append("note", note);
    formData.append("campaign", campaignName);
    formData.append("image", image);
    formData.append("venueName", form.venueName);
    formData.append("marketingCode", form.marketingCode);
    formData.append("affiliatedBrands", form.affiliatedBrands);
    // formData.append("boxColor", boxColor);

    createOrder(formData)
      .then(() => {
        setPending(false);
        next();
      })
      .catch(() => {
        setPending(false);
        alert("Please try again");
      });
  };

  return (
    <div className={`address-container ${isEncore ? "encore-font" : "null"}`}>
      <Container>
        <div style={{ margin: "30px 0px" }}>
          <h2>Review Your Information</h2>
        </div>
        {/* List form values */}
        <Row>
          <Col>
            <Col>
              <Row>
                <p>
                  <strong>First Name:</strong> {form.firstName}
                </p>
              </Row>
              <Row>
                <p>
                  <strong>Last Name:</strong> {form.lastName}
                </p>
              </Row>
            </Col>
            <Col>
              <Row>
                <p>
                  <strong>Company Name:</strong> {form.companyName}
                </p>
              </Row>
              <Row>
                <p>
                  <strong>Address:</strong> {form.streetAddress} {form.suite}{" "}
                  {form.city} {form.state} {form.postalCode}
                </p>
              </Row>
            </Col>
            <Col>
              <Row>
                <p>
                  <strong>Country:</strong> {form.country}
                </p>
              </Row>
              <Row>
                <p>
                  <strong>Venue Name:</strong> {form.venueName}
                </p>
              </Row>
            </Col>
          </Col>
          <Col>
            <Row>
              <p>
                <strong>Box Name:</strong> {product.title}
              </p>
            </Row>
            <Row>
              <p>
                <strong>Note:</strong> {note}
              </p>
            </Row>
            <Row>
              <p>
                <strong>Marketing Code:</strong> {form.marketingCode}
              </p>
            </Row>
            <Row>
              <p>
                <strong>Phone Number:</strong> {form.phoneNumber}
              </p>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              onClick={() => {
                prev();
              }}
              type="submit"
              className="mb-4 border"
            >
              Go Back
            </Button>
          </Col>
          <Col>
            <Button
              onClick={() => {
                handleSubmit();
              }}
              variant="secondary"
              className="mb-4"
            >
              {!pending ? <>Submit</> : <Spinner animation="border" />}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Review;
